module.exports = __webpack_public_path__ + "img/icon_COOK.9810394c.png";